import Vue from 'vue';
import Router from 'vue-router';
import error from '@/components/error';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: '/nexon-america/',
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: '/:locale/',
			redirect: { name: 'aboutNexon' },
			props: true,
		},
		{
			path: '/:locale/about-nexon',
			name: 'aboutNexon',
			component: () => import(/* webpackChunkName: "about-nexon" */ '@/components/corporate/about'),
			props: true,
		},
		{
			path: '/:locale/careers',
			name: 'careers',
			component: () => import(/* webpackChunkName: "careers" */ '@/components/corporate/careers'),
			props: true,
		},
		{
			path: '/:locale/press-releases',
			name: 'pressReleases',
			component: () => import(/* webpackChunkName: "press-releases" */ '@/components/corporate/press-releases'),
			props: true,
		},
		{
			path: '/:locale/press-releases/article-:articleId',
			name: 'pressReleasesArticle',
			component: () => import(/* webpackChunkName: "press-releases" */ '@/components/corporate/press-releases/article'),
			props: true,
		},
		{
			path: '/:locale/ourteam',
			name: 'ourteam',
			component: () => import(/* webpackChunkName: "ourteam" */ '@/components/ourteam'),
			props: true,
		},
		{
			path: '*',
			name: 'error-redirect',
			redirect: () => {
				console.log(location);
				const pathLang = location.pathname.split('/')[2],
					cookieLang = Vue.cookie.get('i18next') || 'en';
				if (pathLang.length !== 2) {
					return {
						path: `/${cookieLang}/error`,
					};
				}
				Vue.cookie.set('i18next', pathLang);
				return {
					path: `/${pathLang}/error`,
				};
			},
		},
		{
			path: '/:locale/error',
			name: 'error',
			component: error,
			props: true,
		},
		{
			path: '/:locale/ourteam/:title',
			name: 'credits',
			component: () => import(/* webpackChunkName: "credits" */ '@/components/ourteam/credits'),
			props: true,
		},
	],
});

router.beforeEach((to, from, next) => {
	const routeLang = to.params.locale || 'en',
		cookieLang = Vue.cookie.get('i18next');
	if (!cookieLang) {
		Vue.cookie.set('i18next', routeLang);
	}
	// <html lang="{routeLang}">
	document.getElementsByTagName('html')[0].lang = routeLang;
	document.body.className = to.name.toLowerCase();
	next();
});

export default router;
